<template>
    <div style="background:#FAFAFA;" class="policeLato">
        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section v-if="isDesktop()">
            <div class="mt-5 pt-5 paralax-cover-image has-background-dim">
                <p class="paralax-cover-image-text">
                <div class="content_home" style="z-index: 1!important;">
                    <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_pme.mrp.header_title[0]') }}</span></h1>
                    <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('devis.devis_pme.mrp.header_title[1]') }}</span></h1>
                </div>
                </p>
            </div>
        </section>

        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section class="mt-5" v-if="isMobile()">
            <div class="paralax-cover-image_mobile has-background-dim_mobile">
                <p class="paralax-cover-image-text_mobile">
                <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                    <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_pme.mrp.header_title[0]') }}</span></h1>
                    <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('devis.devis_pme.mrp.header_title[2]') }}</span></h1>
                </div>
                </p>
            </div>
        </section>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div>
            <div class="container" style="background:#FAFAFA">
                <div class="container justify-content-center row text-center mb-5 mt-5">
                    <p class="mb-3" style="font-weight: 300;color: #ffa409;font-family: Open Sans, sans-serif;font-size:25px!important;">{{ $t('devis.devis_pme.mrp.title[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_pme.mrp.title[1]') }}</span>{{ $t('devis.devis_pme.mrp.title[2]') }} <span class="font-weight-bold">{{ $t('devis.devis_pme.mrp.title[3]') }}</span></p> <br>
                </div>
                <br>

                <div class="row" style="background:#FAFAFA" v-if="isDesktop()">
                    <div class="col-md-10 offset-1" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="wizard-navigation">
                                <div class="wizard-progress-with-circle">
                                    <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                                </div>
                                <div class="progress-bar-group">
                                    <div class="progress-bar-custom" id="testup"></div>
                                </div>
                                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                                    <li class="step" id="firstStep">
                                        <div class="step-title">{{ $t('devis.devis_pme.mrp.stepper_title[0]') }}</div>
                                    </li>
                                    <li class="step" id="secondStep">
                                        <div class="step-title">{{ $t('devis.devis_pme.mrp.stepper_title[1]') }}</div>
                                    </li>
                                    <li class="step" id="thirtStep">
                                        <div class="step-title">{{ $t('devis.devis_pme.mrp.stepper_title[3]') }}</div>
                                      </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" style="background:#FAFAFA" v-if="isMobile()">
                    <div class="col-md-10" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="wizard-navigation">
                            <div class="wizard-progress-with-circle">
                                <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                            </div>
                            <div class="progress-bar-group">
                                <div class="progress-bar-custom" id="testup"></div>
                            </div>
                            <ul role="tablist" class="wizard-nav wizard-nav-pills">
                                <li class="step" id="firstStep">
                                    <div class="step-title text-center mr-4">{{ $t('devis.devis_pme.mrp.stepper_title[0]') }}</div>
                                </li>
                                <li class="step" id="secondStep">
                                    <div class="step-title text-center mr-4">{{ $t('devis.devis_pme.mrp.stepper_title[2]') }}</div>
                                </li>
                                <li class="step" id="thirtStep">
                                    <div class="step-title text-center mr-4">{{ $t('devis.devis_pme.mrp.stepper_title[3]') }}</div>
                                </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>

                <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP     =============== -->
                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                <!-- ========================================================================================= -->
                <div v-responsive.lg.xl class="row mt-5" style="background:#FAFAFA">
                    <div class="col-md-10 offset-1" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">                           
                            <div class="page" v-show="step === 1">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepSimule" aria-hidden="true" aria-labelledby="step-StepSimule" class="wizard-tab-container">
                                        <div>
                                            <div class="fields">
                                                <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="col-sm-12 field-radio field-radio-center">
                                                        <div class="btn-choice">
                                                            <input @click="switchMrp" v-model="choix" value="mrp_value" type="radio" id="mrp" name="offre" class="field-input">
                                                            <label for="mrp" class="field-label btn-choice-hide-dot">MRP</label>
                                                        </div>
                                                        <div class="btn-choice">
                                                            <input @click="switchMrpRc" v-model="choix" value="mrp_rc_value" type="radio" id="mrp_rc" name="offre" class="field-input" >
                                                            <label for="mrp_rc" class="field-label btn-choice-hide-dot">
                                                                {{ $t('devis.devis_pme.mrp.firstStep.title_mrp[2]') }}</label> 
                                                        </div>
                                                        <!-- <div class="btn-choice">
                                                            <input disabled @click="switchRc" v-model="choix" value="rc" type="radio" id="rc" name="offre" class="field-input" >
                                                            <label for="rc" class="field-label btn-choice-hide-dot">
                                                                RC</label> 
                                                        </div> -->
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-show="Mrp">
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                <div class="field-title">{{ $t('devis.devis_pme.mrp.firstStep.title_mrp[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.title_mrp[1]') }}</span> {{ $t('devis.devis_pme.mrp.firstStep.title_mrp[3]') }} &nbsp;:</div>
                                                <!-- <div class="mt-3 field-title font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.locataire_proprio_title') }} &nbsp;:</div> -->
                                                <div class="field-group justify-content-center row flex-column flex-sm-row">
                                                    <div class="btn-choice btn-choice-icon sm-no-change">
                                                        <input @change="CheckFieldChange()" v-model="qualiteassure"
                                                            value="locataire"
                                                            type="radio" id="mrp_locataire" name="mrp_proprio_location" class="field-input">
                                                        <label for="mrp_locataire" class="flex-row flex-md-row field-label">
                                                            <img src="../../assets/img/icones/locataire.png"
                                                                class="mr-4 mr-md-0" alt="locataire">
                                                            <p class="text-center">
                                                                {{ $t('devis.devis_pme.mrp.firstStep.qualite_occupant.label_Locataire') }}
                                                            </p>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice btn-choice-icon sm-no-change ml-4">
                                                        <input @change="CheckFieldChange()" v-model="qualiteassure" type="radio"
                                                            value="occupant"
                                                            id="mrp_occupant" name="mrp_proprio_location" class="field-input">
                                                        <label for="mrp_occupant" class="flex-row flex-md-row field-label">
                                                            <img src="../../assets/img/icones/owner_habitation.png"
                                                                class="mr-4 mr-md-0" alt="owner_habitation">
                                                            <p class="text-center">
                                                                {{ $t('devis.devis_pme.mrp.firstStep.qualite_occupant.label_Proprio_occupant') }}
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>
                                                
                                                <!-- <div class="mt-3 field-title font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.valeur_title') }} &nbsp;:</div> -->
                                                <div class="mt-5 field-title">{{ $t('devis.devis_pme.mrp.firstStep.valeur_title[0]') }}  <span class="font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.valeur_title[1]') }}</span> {{ $t('devis.devis_pme.mrp.firstStep.valeur_title[2]') }} &nbsp;:</div>
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <div v-if="qualiteassure == 'locataire'" class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="loyer_mensuel" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_loyer_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" v-money="money" v-model="valeur_location" id="loyer_mensuel" name="Step8" class="field-input">
                                                        </div>
                                                        <div v-else class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="valeur_batiment" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_batiment_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" v-money="money" v-model="valeur_proprio" id="valeur_batiment" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-4">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="valeur_mobilier" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_mobilier_label') }} *</label>
                                                            <input v-money="money" @keypress="CheckFieldChange()" v-model="valeur_mobilier" placeholder="Saisir la valeur du mobilier" id="valeur_mobilier" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-4">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="chiffre_affaire" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_chiffre_affaire_label') }}</label>
                                                            <input @keypress="CheckFieldChange()" v-money="money" v-model="chiffre_affaire" id="chiffre_affaire" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                                <div class="fields" >
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="justify-content-center row" v-if="monthly_payment!=null">
                                                                <div class="mt-5 mb-3 justify-content-center column" style="width: 250px">
                                                                    <div class="field-title font-weight-bold text-center">{{ $t('devis.devis_pme.mrp.firstStep.prime_annuelle_label') }}</div>
                                                                    <div class="field-title font-weight-bold text-center" style="color:#ffa409;margin-top:-10px">{{monthly_payment.toLocaleString()}} FCFA</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button v-if="Simule" @click="fieldsControl()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_pme.mrp.bouton_simuler_label') }}
                                                    </button>
                                                    <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_pme.mrp.bouton_suivant_label') }}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>

                                        <div v-show="MrpRc">
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="field-title">{{ $t('devis.devis_pme.mrp.firstStep.title_mrp[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.title_mrp[2]') }}</span> {{ $t('devis.devis_pme.mrp.firstStep.title_mrp[3]') }} &nbsp;:</div>
                                                <!-- <div class="mt-3 field-title font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.locataire_proprio_title') }} &nbsp;:</div> -->
                                                <div class="field-group justify-content-center row flex-column flex-sm-row">
                                                    <div class="btn-choice btn-choice-icon sm-no-change">
                                                        <input @change="CheckFieldChange()" v-model="qualiteassure"
                                                            value="locataire"
                                                            type="radio" id="mrp_rc_locataire" name="mrp_rc_proprio_location" class="field-input">
                                                        <label for="mrp_rc_locataire" class="flex-row flex-md-row field-label">
                                                            <img src="../../assets/img/icones/locataire.png"
                                                                class="mr-4 mr-md-0" alt="locataire">
                                                            <p class="text-center">
                                                                {{ $t('devis.devis_pme.mrp.firstStep.qualite_occupant.label_Locataire') }}
                                                            </p>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice btn-choice-icon sm-no-change ml-4">
                                                        <input @change="CheckFieldChange()" v-model="qualiteassure" type="radio"
                                                            value="occupant"
                                                            id="mrp_rc_occupant" name="mrp_rc_proprio_location" class="field-input">
                                                        <label for="mrp_rc_occupant" class="flex-row flex-md-row field-label">
                                                            <img src="../../assets/img/icones/owner_habitation.png"
                                                                class="mr-4 mr-md-0" alt="owner_habitation">
                                                            <p class="text-center">
                                                                {{ $t('devis.devis_pme.mrp.firstStep.qualite_occupant.label_Proprio_occupant') }}
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>
                                                
                                                <!-- <div class="mt-3 field-title font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.valeur_title') }}&nbsp;:</div> -->
                                                <div class="mt-5 field-title">{{ $t('devis.devis_pme.mrp.firstStep.valeur_title[0]') }}  <span class="font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.valeur_title[1]') }}</span> {{ $t('devis.devis_pme.mrp.firstStep.valeur_title[2]') }} &nbsp;:</div>
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <div v-if="qualiteassure == 'locataire'" class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="loyer_mensuel_rc" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_loyer_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" v-money="money" v-model="valeur_location" :placeholder="$t('devis.devis_vie.nsiaetude.firstStep.bourse_souhaite_placeholder')" id="loyer_mensuel_rc" name="Step8" class="field-input">
                                                        </div>
                                                        <div v-else class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="valeur_batiment_rc" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_batiment_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" v-money="money" v-model="valeur_proprio" :placeholder="$t('devis.devis_vie.nsiaetude.firstStep.bourse_souhaite_placeholder')" id="valeur_batiment_rc" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-4">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="valeur_mobilier_rc" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_mobilier_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" v-money="money" v-model="valeur_mobilier" placeholder="Saisir la valeur du mobilier" id="valeur_mobilier_rc" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-4">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="chiffre_affaire_rc" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_chiffre_affaire_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" v-money="money" v-model="chiffre_affaire" :placeholder="$t('devis.devis_vie.nsiaetude.firstStep.bourse_souhaite_placeholder')" id="chiffre_affaire_rc" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                                <div class="fields" >
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="justify-content-center row" v-if="monthly_payment!=null">
                                                                <div class="mt-5 mb-3 justify-content-center column" style="width: 250px">
                                                                    <div class="field-title font-weight-bold text-center">{{ $t('devis.devis_pme.mrp.firstStep.prime_annuelle_label') }}</div>
                                                                    <div class="field-title font-weight-bold text-center" style="color:#ffa409;margin-top:-10px">{{monthly_payment.toLocaleString()}} FCFA</div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button v-if="Simule" @click="fieldsControl()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_pme.mrp.bouton_simuler_label') }}
                                                    </button>
                                                    <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_pme.mrp.bouton_suivant_label') }}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 2">
                                <div class="wizard-tab-content">
                                     <div role="tabpanel" id="StepContractant" aria-hidden="true" aria-labelledby="step-StepContractant" class="wizard-tab-container">
                                         <div v-if="isContractant">
                                             <div class="loan-group loan-group-0">
                                                 <div class="fields">
                                                     <div class="field-title font-weight-bold">{{ $t('devis.devis_pme.mrp.secondStep.title') }} &nbsp;:</div>
                                                     <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <div class="field-checkbox">
                                                                <div class="switch">
                                                                    <label for="contractant_question"><span class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.question_assure_title') }}</span>
                                                                    <input style="margin-top:5px" @change="toggleCheckbox()" v-model="checkbox" type="checkbox" id="contractant_question" name="Step12">
                                                                    <span style="margin-top: 5px;" class="lever"></span>
                                                                    </label>
                                                                </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                 </div>
 
                                                 <div class="fields">
                                                     <div class="row">
                                                         <div class="col-sm-4">
                                                             <div class="field-group field-default mb-4 mb-sm-0">
                                                                 <label for="nom_contractant" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.nom_label') }} *</label>
                                                                 <input v-model="ContractantFields.Nom" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.nom_placeholder')" id="nom_contractant" name="Step8" class="field-input">
                                                             </div>
                                                         </div>
                                                         <div class="col-sm-4">
                                                             <div class="field-group field-default mb-4 mb-sm-0">
                                                                 <label for="prenom_contractant" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.prenom_label') }} *</label>
                                                                 <input v-model="ContractantFields.Prenom" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.prenom_placeholder')" id="prenom_contractant" name="Step8" class="field-input">
                                                             </div>
                                                         </div>
                                                         <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="adresse_contractant" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.adresse_label') }} *</label>
                                                                <input v-model="ContractantFields.Adresse" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.adresse_placeholder')" id="adresse_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                     </div>
                                                 </div>
 
                                                 <div class="fields">
                                                     <div class="row">
                                                         <div class="col-sm-6">
                                                             <div class="field-group field-default mb-4 mb-sm-0">
                                                                 <label for="telephone_contractant" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.telephone_label') }} *</label>
                                                                 <input v-model="ContractantFields.Telephone" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.telephone_placeholder')" id="telephone_contractant" name="Step8" class="field-input">
                                                             </div>
                                                         </div>
                                                         <div class="col-sm-6">
                                                             <div class="field-group field-default mb-4 mb-sm-0">
                                                                 <label for="email_contractant" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.email_label') }} *</label>
                                                                 <input v-model="ContractantFields.Email" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.email_placeholder')" id="email_contractant" name="Step8" class="field-input">
                                                             </div>
                                                         </div>
                                                     </div>
                                                 </div>


                                                 <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nom_societe" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.nom_societe_label') }} *</label>
                                                                <input v-model="ContractantFields.nom_societe" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.nom_societe_placeholder')" id="nom_societe" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="situation_societe" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.lieux_assurance_label') }} *</label>
                                                                <input v-model="ContractantFields.situation_chantier" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.lieux_assurance_placeholder')" id="situation_societe" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields" v-if="this.choixOffreFinale == 'Mrp_rc_value'">
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="activity_societe" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.activite_principale_label') }} *</label>
                                                                <input v-model="ContractantFields.activity_society" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.activite_principale_placeholder')" id="activity_societe" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nombre_employer" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.nombre_employe_label') }}</label>
                                                                <input type="number" v-model="ContractantFields.employe_number" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.nombre_employe_placeholder')" id="nombre_employer" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                             </div>
 
                                             <div class="wizard-card-footer clearfix mb-5">
                                                 <div class="wizard-footer-left">
                                                     <button @click="returToFirstStep()" type="button" class="wizard-btn">
                                                     <span class="fas fa-arrow-left"></span>
                                                     {{$t('devis.devis_pme.mrp.bouton_retour_label')}}
                                                     </button>
                                                 </div>
                                                 <div class="wizard-footer-right">
                                                     <button @click="ContractControl()" type="button" class="wizard-btn">
                                                     {{$t('devis.devis_pme.mrp.bouton_suivant_label')}}
                                                     </button>
                                                 </div>
                                                 <!---->
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                            </div>

                            <div class="page" v-if="isPayment">
                                <div class="wizard-tab-content">
                                <div role="tabpanel" id="StepRecap" aria-labelledby="step-StepRecap" class="wizard-tab-container">
                                    <div>
                                    <div class="fields">
                                        <section class="section-sm-bottom-85">
                                        <div class="container mt-1">
                                            <div class="row gx-xxl-6">
                                            <div class="col-12 col-lg-12">
                                                <div class="row">
                                                <div class="col-12">
                                                    <div class="post">
                                                    <div class="post-body">
                                                        <div>
                                                        <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                                            <div class="form">
                                                            <div class="page">
                                                                <div class="wizard-tab-content">
                                                                <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_pme.mrp.validationStep.title') }} :</div>
                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_pme.mrp.validationStep.contractant.title') }}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div class="row" style="margin-top: -20px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">

                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.nom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.Nom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.prenom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.Prenom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.adresse_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.Adresse}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.telephone_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.Telephone}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.email_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.Email}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.situation_label') }} :
                                                                                <span class="font-weight-bold to-right">{{ContractantFields.situation_chantier}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.nom_socite_label') }} :
                                                                                <span class="font-weight-bold to-right">{{ContractantFields.nom_societe}}</span>
                                                                            </li>

                                                                            <li v-if="this.choixOffreFinale == 'Mrp_rc_value'" class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.activite_label') }} :
                                                                                <span class="font-weight-bold to-right">{{ContractantFields.activity_society}}</span>
                                                                            </li>

                                                                            <li v-if="this.choixOffreFinale == 'Mrp_rc_value'" class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.nombre_employe_label') }} :
                                                                                <span class="font-weight-bold to-right">{{ContractantFields.employe_number}}</span>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_pme.mrp.validationStep.garantie.title') }}</p>
                                                                    </div>
                                                                    </div>

                                                                    <div class="row" style="margin-top: -20px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.garantie.duree_label') }} :
                                                                            <span class="font-weight-bold to-right">{{duree}} {{ $t('devis.devis_pme.mrp.validationStep.garantie.mois_label') }}(s)</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.garantie.prime_nette_label') }} :
                                                                            <span class="font-weight-bold to-right">{{this.prime_nette.toLocaleString()}} FCFA</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.garantie.taxe_label') }} :
                                                                                <span class="font-weight-bold to-right">{{taxe.toLocaleString()}} FCFA</span>
                                                                            </li>
                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.garantie.accessoire_label') }} :
                                                                                <span class="font-weight-bold to-right">{{accessoire.toLocaleString()}} FCFA</span>
                                                                            </li>


                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.garantie.prime_ttc_label') }} :
                                                                                <span class="font-weight-bold to-right">{{monthly_payment.toLocaleString()}} FCFA</span>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_pme.mrp.validationStep.periode.title') }}</p>
                                                                    </div>
                                                                    </div>

                                                                    <div class="row">
                                                                    <div class="col-sm-6">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper39" class="field-label">{{ $t('devis.devis_pme.mrp.validationStep.periode.date_effet') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <date-picker id="Stepper39" :disabled-date="disabledAfterToday" class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.nsiaetude.validationStep.periode.date_effet_placeholder')" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-6">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper40" class="field-label">{{ $t('devis.devis_pme.mrp.validationStep.periode.date_echeance') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <input disabled :placeholder="$t('devis.devis_pme.mrp.validationStep.periode.date_echeance_placeholder')" v-model="dateEcheance" id="Stepper40" name="Step11" class="field-input">
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                                </div>
                                                                <div class="wizard-card-footer clearfix mb-3">
                                                                <div class="wizard-footer-left">
                                                                    <button @click="returToSecondStep()" type="button" class="wizard-btn">
                                                                    <span class="fas fa-arrow-left"></span>
                                                                    {{$t('devis.devis_pme.mrp.bouton_retour_label')}}
                                                                    </button>
                                                                </div>
                                                                <div class="wizard-footer-right">
                                                                    <button :disabled="disabledButtonValidate" @click="CreateDevis()" type="button" class="wizard-btn">
                                                                        {{ $t('devis.devis_pme.mrp.bouton_valider_label') }}
                                                                    </button>
                                                                </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </section>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                <!-- ========================================================================================= -->
                <div v-responsive.sm.xs>
                    <div class="mt-5" style="background:#FAFAFA">
                    <div class="row" style="background:#FAFAFA">

                    <div class="col-md-10" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="page" v-show="step === 1">
                                <div class="wizard-tab-content">
                                    <div role="tabpanel" id="Step1_mobile" aria-labelledby="step-Step1_mobile" class="wizard-tab-container">
                                        <div>
                                        <div class="fields">
                                            <div class="row">
                                            <div class="col-sm-12">
                                                <div class="col-sm-12 field-radio field-radio-center">
                                                    <div class="btn-choice">
                                                        <input @click="switchMrp" v-model="choix" value="mrp_value" type="radio" id="mrp_mobile" name="offre_mobile" class="field-input">
                                                        <label for="mrp_mobile" class="field-label btn-choice-hide-dot">MRP</label>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 field-radio field-radio-center mt-3">
                                                    <div class="btn-choice">
                                                        <input @click="switchMrpRc" v-model="choix" value="mrp_rc_value" type="radio" id="mrp_rc_mobile" name="offre_mobile" class="field-input" >
                                                        <label for="mrp_rc_mobile" class="field-label btn-choice-hide-dot">
                                                            {{ $t('devis.devis_pme.mrp.firstStep.title_mrp[2]') }}</label> 
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-show="Mrp">
                                    <div class="loan-group loan-group-0" style="z-index:0!important">
                                        <div class="fields">
                                            <div class="field-title">{{ $t('devis.devis_pme.mrp.firstStep.title_mrp[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.title_mrp[1]') }}</span> {{ $t('devis.devis_pme.mrp.firstStep.title_mrp[3]') }} &nbsp;:</div>
                                            <!-- <div class="mt-3 field-title font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.locataire_proprio_title') }} &nbsp;:</div> -->
                                            <div class="field-group justify-content-center row flex-column flex-sm-row">
                                                <div class="btn-choice btn-choice-icon sm-no-change">
                                                    <input @change="CheckFieldChange()" v-model="qualiteassure"
                                                        value="locataire"
                                                        type="radio" id="mrp_locataire_mobile" name="mrp_proprio_location_mobile" class="field-input">
                                                    <label for="mrp_locataire_mobile" class="flex-row flex-md-row field-label">
                                                        <img src="../../assets/img/icones/locataire.png"
                                                            class="mr-4 mr-md-0" alt="locataire">
                                                        <p class="text-center">
                                                            {{ $t('devis.devis_pme.mrp.firstStep.qualite_occupant.label_Locataire') }}
                                                        </p>
                                                    </label>
                                                </div>
                                                <div class="btn-choice btn-choice-icon sm-no-change">
                                                    <input @change="CheckFieldChange()" v-model="qualiteassure" type="radio"
                                                        value="occupant"
                                                        id="mrp_occupant_mobile" name="mrp_proprio_location_mobile" class="field-input">
                                                    <label for="mrp_occupant_mobile" class="flex-row flex-md-row field-label">
                                                        <img src="../../assets/img/icones/owner_habitation.png"
                                                            class="mr-4 mr-md-0" alt="owner_habitation">
                                                        <p class="text-center">
                                                            {{ $t('devis.devis_pme.mrp.firstStep.qualite_occupant.label_Proprio_occupant') }}
                                                        </p>
                                                    </label>
                                                </div>
                                            </div>

                                            <div class="mt-3 row">
                                                <div class="mt-3 field-title font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.valeur_title[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.valeur_title[1]') }}</span> {{ $t('devis.devis_pme.mrp.firstStep.valeur_title[2]') }} &nbsp;:</div>
                                                <div class="col-sm-12">
                                                    <div v-if="qualiteassure == 'locataire'" class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="loyer_mensuel_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_loyer_label') }} *</label>
                                                        <input @keypress="CheckFieldChange()" v-money="money" v-model="valeur_location" id="loyer_mensuel_mobile" name="Step8" class="field-input">
                                                    </div>
                                                    <div v-else class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="valeur_batiment_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_batiment_label') }} *</label>
                                                        <input @keypress="CheckFieldChange()" v-money="money" v-model="valeur_proprio" id="valeur_batiment_mobile" name="Step8" class="field-input">
                                                    </div>
                                                </div>
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="valeur_immobilier_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_mobilier_label') }} *</label>
                                                        <input @keypress="CheckFieldChange()" v-money="money" v-model="valeur_mobilier" id="valeur_immobilier_mobile" name="Step8" class="field-input">
                                                    </div>
                                                </div>
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="chiffre_affaire_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_chiffre_affaire_label') }}</label>
                                                        <input @keypress="CheckFieldChange()" v-money="money" v-model="chiffre_affaire" id="chiffre_affaire_mobile" name="Step8" class="field-input">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="fields" >
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="justify-content-center row" v-if="monthly_payment!=null">
                                                        <div class="mt-5 mb-3 justify-content-center column" style="width: 250px">
                                                            <div class="field-title font-weight-bold text-center">{{ $t('devis.devis_pme.mrp.firstStep.prime_annuelle_label') }}</div>
                                                            <div class="field-title font-weight-bold text-center" style="color:#ffa409;margin-top:-10px">{{monthly_payment.toLocaleString()}} FCFA</div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="wizard-card-footer clearfix mb-5">
                                        <div class="wizard-footer-left">
                                        </div>
                                        <div class="wizard-footer-right">
                                            <button v-if="Simule" @click="fieldsControl()" type="button" class="wizard-btn">
                                                {{ $t('devis.devis_pme.mrp.bouton_simuler_label') }}
                                            </button>
                                            <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                                                {{ $t('devis.devis_pme.mrp.bouton_suivant_label') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div v-show="MrpRc">
                                        <div class="loan-group loan-group-0" style="z-index:0!important">
                                            <div class="fields">
                                                <div class="field-title">{{ $t('devis.devis_pme.mrp.firstStep.title_mrp[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.title_mrp[2]') }}</span> {{ $t('devis.devis_pme.mrp.firstStep.title_mrp[3]') }} &nbsp;:</div>
                                                <!-- <div class="mt-3 field-title font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.locataire_proprio_title') }} &nbsp;:</div> -->
                                                <div class="field-group justify-content-center row flex-column flex-sm-row">
                                                    <div class="btn-choice btn-choice-icon sm-no-change">
                                                        <input @change="CheckFieldChange()" v-model="qualiteassure"
                                                            value="locataire"
                                                            type="radio" id="mrp_rc_locataire_mobile" name="mrp_rc_proprio_location_mobile" class="field-input">
                                                        <label for="mrp_rc_locataire_mobile" class="flex-row flex-md-row field-label">
                                                            <img src="../../assets/img/icones/locataire.png"
                                                                class="mr-4 mr-md-0" alt="locataire">
                                                            <p class="text-center">
                                                                {{ $t('devis.devis_pme.mrp.firstStep.qualite_occupant.label_Locataire') }}
                                                            </p>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice btn-choice-icon sm-no-change">
                                                        <input @change="CheckFieldChange()" v-model="qualiteassure" type="radio"
                                                            value="occupant"
                                                            id="mrp_rc_occupant_mobile" name="mrp_rc_proprio_location_mobile" class="field-input">
                                                        <label for="mrp_rc_occupant_mobile" class="flex-row flex-md-row field-label">
                                                            <img src="../../assets/img/icones/owner_habitation.png"
                                                                class="mr-4 mr-md-0" alt="owner_habitation">
                                                            <p class="text-center">
                                                                {{ $t('devis.devis_pme.mrp.firstStep.qualite_occupant.label_Proprio_occupant') }}
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div class="mt-3 row">
                                                    <!-- <div class="mt-3 field-title font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.valeur_title') }} &nbsp;:</div> -->
                                                    <div class="mt-3 field-title font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.valeur_title[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_pme.mrp.firstStep.valeur_title[1]') }}</span> {{ $t('devis.devis_pme.mrp.firstStep.valeur_title[2]') }} &nbsp;:</div>
                                                    <div class="col-sm-12">
                                                        <div v-if="qualiteassure == 'locataire'" class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="loyer_mobile_rc_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_loyer_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" v-money="money" v-model="valeur_location" id="loyer_mobile_rc_mobile" name="Step8" class="field-input">
                                                        </div>
                                                        <div v-else class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="valeur_batiment_rc_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_batiment_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" v-money="money" v-model="valeur_proprio" id="valeur_batiment_rc_mobile" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="valeur_immobilier_rc_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_mobilier_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" v-money="money" v-model="valeur_mobilier" id="valeur_immobilier_rc_mobile" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="chiffre_affaire_rc_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.firstStep.valeur_chiffre_affaire_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" v-money="money" v-model="chiffre_affaire" id="chiffre_affaire_rc_mobile" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="fields" >
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <div class="justify-content-center row" v-if="monthly_payment!=null">
                                                            <div class="mt-5 mb-3 justify-content-center column" style="width: 250px">
                                                                <div class="field-title font-weight-bold text-center">{{ $t('devis.devis_pme.mrp.firstStep.prime_annuelle_label') }}</div>
                                                                <div class="field-title font-weight-bold text-center" style="color:#ffa409;margin-top:-10px">{{monthly_payment.toLocaleString()}} FCFA</div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wizard-card-footer clearfix mb-5">
                                            <div class="wizard-footer-left">
                                            </div>
                                            <div class="wizard-footer-right">
                                                <button v-if="Simule" @click="fieldsControl()" type="button" class="wizard-btn">
                                                    {{ $t('devis.devis_pme.mrp.bouton_simuler_label') }}
                                                </button>
                                                <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                                                    {{ $t('devis.devis_pme.mrp.bouton_suivant_label') }}
                                                </button>
                                            </div>
                                        </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 2">
                                <div class="wizard-tab-content">
                                        <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8" class="wizard-tab-container">
                                            <div v-if="isContractant">
                                                <div class="loan-group loan-group-0">
                                                    <div class="fields">
                                                        <div class="field-title font-weight-bold">{{ $t('devis.devis_pme.mrp.secondStep.title') }}&nbsp;:</div>
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <div class="field-checkbox">
                                                                    <!-- <div class="field-label">
                                                                        Le contractant est l'assuré ?
                                                                    </div> -->
                                                                    <div class="switch">
                                                                        <label for="contractant_question"><span class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.question_assure_title') }}</span>
                                                                        <input style="margin-top:5px" @change="toggleCheckbox()" v-model="checkbox" type="checkbox" id="contractant_question" name="Step12">
                                                                        <span style="margin-top: 5px;" class="lever"></span>
                                                                        </label>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="fields">
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="nom_contractant_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.nom_label') }}</label>
                                                                    <input v-model="ContractantFields.Nom" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.nom_placeholder')" id="nom_contractant_mobile" name="Step8" class="field-input">
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-12">
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="prenom_contractant_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.prenom_label') }}</label>
                                                                    <input v-model="ContractantFields.Prenom" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.prenom_placeholder')" id="prenom_contractant_mobile" name="Step8" class="field-input">
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-12">
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="adresse_contractant_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.adresse_label') }}</label>
                                                                    <input v-model="ContractantFields.Adresse" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.adresse_placeholder')" id="adresse_contractant_mobile" name="Step8" class="field-input">
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-12">
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="telephone_contractant_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.telephone_label') }}</label>
                                                                    <input v-model="ContractantFields.Telephone" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.telephone_placeholder')" id="telephone_contractant_mobile" name="Step8" class="field-input">
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-12">
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="email_contractant_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.email_label') }}</label>
                                                                    <input v-model="ContractantFields.Email" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.email_placeholder')" id="email_contractant_mobile" name="Step8" class="field-input">
                                                                </div>
                                                            </div>

                                                            <div class="col-sm-12">
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="nom_societe_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.nom_societe_label') }}</label>
                                                                    <input v-model="ContractantFields.nom_societe" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.nom_societe_placeholder')" id="nom_societe_mobile" name="Step8" class="field-input">
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-12">
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="situation_societe_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.lieux_assurance_label') }}</label>
                                                                    <input v-model="ContractantFields.situation_chantier" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.lieux_assurance_placeholder')" id="situation_societe_mobile" name="Step8" class="field-input">
                                                                </div>
                                                            </div>

                                                            <div class="col-sm-12" v-if="this.choixOffreFinale == 'Mrp_rc_value'">
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="activity_societe_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.activite_principale_label') }}</label>
                                                                    <input v-model="ContractantFields.activity_society" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.activite_principale_placeholder')" id="activity_societe_mobile" name="Step8" class="field-input">
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-12" v-if="this.choixOffreFinale == 'Mrp_rc_value'">
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="nombre_employer_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.secondStep.contractant_form.nombre_employe_label') }}</label>
                                                                    <input type="number" v-model="ContractantFields.employe_number" :placeholder="$t('devis.devis_pme.mrp.secondStep.contractant_form.nombre_employe_placeholder')" id="nombre_employer_mobile" name="Step8" class="field-input">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="wizard-card-footer clearfix mb-5">
                                                    <div class="wizard-footer-left">
                                                        <button @click="returToFirstStep()" type="button" class="wizard-btn">
                                                        <span class="fas fa-arrow-left"></span>
                                                        {{$t('devis.devis_pme.mrp.bouton_retour_label')}}
                                                        </button>
                                                    </div>
                                                    <div class="wizard-footer-right">
                                                        <button @click="ContractControl()" type="button" class="wizard-btn">
                                                            {{$t('devis.devis_pme.mrp.bouton_suivant_label')}}
                                                        </button>
                                                    </div>
                                                    <!---->
                                                </div>
                                            </div>
                                        </div>
                                </div>
                            </div>

                            <div class="page review_page" v-if="isPayment">
                                <div data-v-221edead="" class="w-100 Results" pricing="true" style="--custom-color-primary:#35CE7E; --custom-color-primary-light:#5CC7000d;">
                                <div role="tabpanel" id="devis_iAc" aria-labelledby="step-devis_iAc" class="wizard-tab-container">
                                    <div data-v-0d43d413="">
                                    <div data-v-0d43d413="" class="fields">
                                        <div data-v-0d43d413="" class="font-weight-bold field-title mb-0 row justify-content-center">
                                            {{ $t('devis.devis_pme.mrp.validationStep.title') }}
                                        </div>
                                    </div>
                                    </div>
                                </div>

                                <div data-v-221edead="">
                                    <div data-v-221edead="" class="results-deals">
                                    <div data-v-221edead="" id="results-table">
                                        <div data-v-221edead="" style="top: 0px; width: 100%;">
                                        <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                            <div data-v-221edead="" class="card-default-body">
                                            <h1 class="field-title row justify-content-center">{{ $t('devis.devis_pme.mrp.validationStep.contractant.title') }}</h1>
                                            <div data-v-221edead="" class="logo-company logo-company-economy">
                                                <ul class="to-left mb-3 policeLato" style="width: 100%!important;margin-left: 20px!important;margin-right: 20px!important;">
                                                    <li  class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.nom_label') }} :
                                                    <span class="font-weight-bold to-right">{{ContractantFields.Nom}}</span>
                                                    </li>

                                                    <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.prenom_label') }} :
                                                    <span class="font-weight-bold to-right">{{ContractantFields.Prenom}}</span>
                                                    </li>

                                                    <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.adresse_label') }} :
                                                    <span class="font-weight-bold to-right">{{ContractantFields.Adresse}}</span>
                                                    </li>

                                                    <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.telephone_label') }} :
                                                    <span class="font-weight-bold to-right">{{ContractantFields.Telephone}}</span>
                                                    </li>

                                                    <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.email_label') }} :
                                                    <span class="font-weight-bold to-right">{{ContractantFields.Email}}</span>
                                                    </li>

                                                    <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.situation_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.situation_chantier}}</span>
                                                    </li>

                                                    <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.nom_socite_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.nom_societe}}</span>
                                                    </li>

                                                    <li v-if="this.choixOffreFinale == 'Mrp_rc_value'" class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.activite_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.activity_society}}</span>
                                                    </li>

                                                    <li v-if="this.choixOffreFinale == 'Mrp_rc_value'" class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.contractant.nombre_employe_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.employe_number}}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>

                                <div data-v-221edead="">
                                    <div data-v-221edead="" class="results-deals">
                                    <div data-v-221edead="" id="results-table">
                                        <div data-v-221edead="" style="top: 0px; width: 100%;">
                                        <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                            <div data-v-221edead="" class="card-default-body">
                                            <h1 class="field-title row justify-content-center">{{ $t('devis.devis_pme.mrp.validationStep.garantie.title') }}</h1>
                                            <div data-v-221edead="" class="logo-company logo-company-economy">
                                                <ul class="to-left mb-3 policeLato" style="width: 100%!important;margin-left: 20px!important;margin-right: 20px!important;">
                                                    <li  class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.garantie.duree_label') }} :
                                                    <span class="font-weight-bold to-right">{{duree}} {{ $t('devis.devis_pme.mrp.validationStep.garantie.mois_label') }}(s)</span>
                                                    </li>

                                                    <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.garantie.prime_nette_label') }} :
                                                    <span class="font-weight-bold to-right">{{this.prime_nette.toLocaleString()}} FCFA</span>
                                                    </li>

                                                    <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.garantie.taxe_label') }} :
                                                    <span class="font-weight-bold to-right">{{taxe.toLocaleString()}} FCFA</span>
                                                    </li>

                                                    <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.garantie.accessoire_label') }} :
                                                    <span class="font-weight-bold to-right">{{accessoire.toLocaleString()}} FCFA</span>
                                                    </li>

                                                    <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.mrp.validationStep.garantie.prime_ttc_label') }} :
                                                    <span class="font-weight-bold to-right">{{monthly_payment.toLocaleString()}} FCFA</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>


                                <div role="tabpanel" id="devis_auto" aria-labelledby="step-devis_auto" class="mt-3 wizard-tab-container">
                                <div data-v-0d43d413="">
                                <div data-v-0d43d413="" class="fields">
                                    <div data-v-0d43d413="" class="font-weight-bold field-title mb-0 row justify-content-center">
                                        {{ $t('devis.devis_pme.mrp.validationStep.periode.title') }}
                                    </div>

                                    <div class="row">
                                    <div class="col-sm-6">
                                        <div class="field-group field-default mb-4 mb-sm-0">
                                        <label for="Stepper39_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.validationStep.periode.date_effet') }}
                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                        <div class="input-group rate-loan">
                                            <date-picker id="Stepper39_mobile" :disabled-date="disabledAfterToday"  class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_pme.mrp.validationStep.periode.date_effet_placeholder')" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                        </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="field-group field-default mb-4 mb-sm-0">
                                        <label for="Stepper40_mobile" class="field-label">{{ $t('devis.devis_pme.mrp.validationStep.periode.date_echeance') }}
                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                        <div class="input-group rate-loan">
                                            <input disabled :placeholder="$t('devis.devis_pme.mrp.validationStep.periode.date_echeance_placeholder')" v-model="dateEcheance" id="Stepper40_mobile" name="Step11" class="field-input">
                                        </div>
                                        </div>
                                    </div>
                                    </div>

                                </div>
                                </div>
                            </div>

                                </div>

                                <div class="wizard-card-footer clearfix">
                    <div class="wizard-footer-left">
                    <button @click="returToSecondStep()" type="button" class="wizard-btn">
                        <span class="fas fa-arrow-left"></span>
                        {{$t('devis.devis_pme.mrp.bouton_retour_label')}}
                        </button>
                    </div>
                    <div class="wizard-footer-right">
                    <button :disabled="disabledButtonValidate" @click="CreateDevis()" type="button" class="wizard-btn">
                        {{ $t('devis.devis_pme.mrp.bouton_valider_label') }}
                    </button>
                    </div>
                    <!---->
                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                </div>
            </div>
        </div>

        <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{$t('devis.devis_voyage.devis_encours')}}</span>
    </div>

        <!-- <v-dialog v-model="dialogLoading" persistent width="700" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                    <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                    <div>
                        <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                            <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular> 
                            <span class="field-title font-weight-bold" style="color:#fff">{{$t('devis.devis_voyage.devis_encours')}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogLoading" persistent width="700" v-if="isMobile()">
            <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                    <div>
                    <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                            <span class="field-title font-weight-bold" style="color:#fff">{{$t('devis.devis_voyage.devis_encours')}}</span>
                        </div>
                        <div class="fields text-center" style="background:#FFA409">
                            <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </v-card-text>
            </v-card>
        </v-dialog> -->

        <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
        <login-form :visible="showLoginForm" @close="showLoginForm=false"></login-form>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import Api from '../../services/Api'
    import store from '../../store/store'
    import LoginForm from './../auth/Login'
    import configMrpConfig from '../../common/mrp_config.json'

    const validateEmail = email => {
        if (!email.length) {
            return {valide: false, error: "L'adresse mail est obligatoire!"};
        } else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            return { valide: false, error: "Veuillez entrer un email valide!" };
        } else {
            return { valide: true, error: null };
        }
    };

    const validatePhone = phone => {

        if(!phone.length){
            return { valide: false, error: 'Le numéro de téléphone est obligatoire.' };
        }else if (phone.length < 9) {
            return { valide: false, error: 'Le numéro de téléphone doit contenir 9 chiffres au minimum.' };
        }else{
            return { valide: true, error: null };
        }

    };

    export default {
        name: 'Devis_trc',
        components: {
            LoginForm
        },
        data() {
            return {
                mrpRcOption : false,
                test_model : null,
                configMpr : null,
                valeur_location : null,
                valeur_proprio : null,
                chiffre_affaire : null,
                qualiteassure : 'occupant',
                rc : false,
                accessoire : 5000,
                taxe : null, 
                duree : 12,
                prime_nette : null, 
                prime_ttc : null,
                primeRc : null,


                valeur_mobilier : null,
                structure_a : {
                    valeurTTC : null,
                    nbreEtage : null,
                    type_structure : null,
                    duree : null,
                },
                structure_b : {
                    valeurTTC : 0,
                    nbreEtage : null,
                    type_structure : null,
                    duree : null,
                },
                nbreEtageAutre : null,
                genre : null,
                // Contractant fields
                ContractantFields: {
                    Genre: null,
                    Situation: null,
                    Nom: null,
                    Prenom: null,
                    Adresse: null,
                    Telephone: null,
                    Email: null,
                    situation_chantier : null,
                    nom_societe : null,
                    activity_society : null,
                    employe_number : null
                },

                formSteps: [
                    {
                        title: "CONTRACTANT",
                        fields: [
                            { valid: true },
                        ]
                    }
                ],
                CreatedDevis:null,

                step : 1,
                choix : 'mrp_value',
                disabledButtonValidate : false,
                dialogLoading : false,
                buttons: false,
                buttons_2: false,
                buttons_3: false,
                buttons_4: false,
                buttons_5: false,
                first_page : false,
                second_page : false,
                thirst_page : false,
                fourt_page : false,
                five_page : false,
                questionTest:'',
                dureeCotisation : [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
              
                QuestionMedical: null,
                PaymentFutur : null,
                
                Duree_bourse :null,
                oldDate : null,
                bottomPushNotif : false,
                disableDateAssure: true,
                Modalite : null,
                Assureur :'',
                Simule : true,
                SkipSimule : false,
                money:{
                    thousands: ' ',
                    precision: false,
                    masked: false,
                },
                choixOffre:null,
                choixOffreFinale: null,
                dateNaiss : null,
                Mrp:true,
                MrpRc: false,
                Capi_souhaite: null,
                rente_an: null,
                pourcent: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
                choixMrp:{
                    Mrp: null,
                    MrpRc : null,
                },
                dateEffet: null,
                dateEcheance: null,
                e1: 1,
                elevation: 2,
                activeStep: 0,
                checkbox: false,
                errors: {},
                aStorMap: false,
                disable: false,
                valide: null,
                age: null,

                // numTelephone : '' ,
                amenities: [1, 4],
                genre: null,

                fraisLiv: 0,
                fraisPaiement: 0,
                Testons: false,
                itemsGenre: ["Homme", "Femme"],
                adresselivraison: "",
                autoHeight: true,
                x: null,
                dialogAlert: false,
                Devis_pour_souscription: [],
                mode_livraison: null,
                //listVille: ville,

                menuDelivrance: false,
                Calculated_response:null,
                monthly_payment:null,
                mode_payement: null,
                notifDeviParMail: null,
                countries: null,
                ville: null,
                quartier: "",
                listegaranties: [],
                marque: null,
                tableau_info_passager: [],
                nbPassager: null,
                frais_livraison: null,
                branche: null,
                continue_btn: false,
                dialogInfoPassager: false,
                dialog: false,
                city: null,
                datePickerDateNais: false,
                IsPaid: false,
                adresse: false,
                livePaper: false,
                checked : false,
                showLoginForm: false,
                animation: 'animate-in',
                NomAssure: null,
                isContractant: true,
                isPayment : false,
                menu: false,
                Capi : 0,
                Mensu: 0,
                ToastTabSucess: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 4000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                }, // Customized options for success toast
                ToastTabError: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 4000,
                    fitToScreen: true,
                    type: 'error'
                }, // Customized options for error toast
                // Contractant fields
               
                CreatedDevis:null,
            }
        },
        methods: {
            toggleCheckbox() {
                if(this.checkbox == true){
                    this.ContractantFields.Nom = this.$store.state.user.nom
                    this.ContractantFields.Prenom = this.$store.state.user.prenom
                    this.ContractantFields.Telephone = this.$store.state.user.telephone_port
                    this.ContractantFields.Email = this.$store.state.user.email
                    this.ContractantFields.Adresse = this.$store.state.user.adresse


                    this.disableDateAssure = true
                    // this.AssureControl()
                    // this.DynamicSimule()
                }else if(this.checkbox == false){
                    this.clearFormContractant()
                }
            },

            toRecapStep(){
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                    this.isPayment = true
                }, 600);
            },

            CreateDevis() {
                let loyer_mensuel;
                if (!store.state.isUserLoggedIn) {
                    this.showLoginForm = true
                } else {
                    if(this.dateEffet) {
                        // if(this.PaymentFutur == null) {
                        //     this.PaymentFutureMode = true
                        // } else {
                            this.PaymentFutureMode = false 
                            if(this.qualiteassure == 'locataire') {
                                loyer_mensuel =  Number(this.valeur_location.replace(/[^0-9.-]+/g, ""))
                            }else {
                                loyer_mensuel = null
                            }
                            const Mrp = {
                                    userid: store.state.user._id,
                                    clientid: store.state.user._id,
                                    branche:'Multirisque Professionnelle',
                                    assureurs:'FINAFRICA',
                                    createur: store.state.user._id,
                                    duree:this.duree,
                                    dateEffet: this.dateEffet,
                                    dateEcheance: this.dateEcheance,
                                    dateSouscription:  dayjs(new Date()).format('YYYY-MM-DD'),
                                    souscripteur: this.ContractantFields,
                                    mrpRc : this.mrpRcOption,
                                    taxe : this.taxe,
                                    accessoires : this.accessoire,
                                    prime_nette : this.prime_nette,
                                    prime_ttc : this.monthly_payment,
                                    garanties :['INCENDIE', 'VOL', 'BRIS DE GLACES','DEGAT DES EAUX'],
                                    valeur_batiment : Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")),
                                    loyer_mensuel : loyer_mensuel,
                                    ca : Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")),
                                    valeur_mobilier : Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")),
                                    plateforme:"Front",
                                    FuturPaiement : this.PaymentFutur,

                            }

                            this.disabledButtonValidate = true;
                            this.dialogLoading = true;

                            Api().post('mrp/create/devis', Mrp).then((result) => {
                                document.getElementById("testup").classList.add('widthThirt');
                                document.getElementById("thirtStep").classList.add('checked');
                                Api().get('devis/' + result.data.devis._id).then(response => {
                                                this.$store.dispatch('setDevisPayement', response.data);
                                                    this.dialogLoading = false, 
                                                    this.disabledButtonValidate = false, 
                                                    this.$router.push('/payement') 
                                            })
                            }).catch((err) => {
                                    console.log('error')
                                });
                    } else {
                        this.$toasted.show( "Date d'effet obligatoire!", this.ToastTabError)
                    }
                }
            },

            DevisNextStep(){
                if(this.monthly_payment < 10000){
                    this.$toasted.show("La prime mensuelle doit étre supérieure a 10 000 FCFA !", this.ToastTabError)
                }else {
                    if (!store.state.isUserLoggedIn) {
                        this.showLoginForm = true
                    } else if(store.state.isUserLoggedIn){
                       this.step = 2;
                        document.getElementById("testup").classList.add('widthFirst');
                        document.getElementById("firstStep").classList.add('checked');
                    }
                }
            },

            ContractControl() {
                this.errors = {}
                        if (this.ContractantFields.Nom && this.ContractantFields.Prenom) {
                                if(this.ContractantFields.Adresse){
                                    if(this.ContractantFields.Telephone && this.ContractantFields.Email){
                                        const validPhone = validatePhone(this.ContractantFields.Telephone);
                                        this.errors.phone = validPhone.error;
                                        const validEmail = validateEmail(this.ContractantFields.Email);
                                        this.errors.email = validEmail.error;
                                        if(validEmail.valide == true && validPhone.valide == true){

                                            if(this.ContractantFields.situation_chantier && this.ContractantFields.nom_societe) {
                                                if(this.choixOffreFinale == 'Mrp_rc_value') {
                                                    if(this.ContractantFields.activity_society) {
                                                        this.activeStep += 1
                                                        this.isContractant = false;
                                                        this.isPayment = true;
                                                        document.getElementById("testup").classList.add('widthSecond');
                                                        document.getElementById("secondStep").classList.add('checked');
                                                    }else {
                                                        this.$toasted.show('Activité de la société obligatoire! ', this.ToastTabError)
                                                    }
                                                    } else  {
                                                        this.activeStep += 1
                                                        this.isContractant = false;
                                                        this.isPayment = true;
                                                        document.getElementById("testup").classList.add('widthSecond');
                                                        document.getElementById("secondStep").classList.add('checked');
                                                    }
                                            } else  {
                                                this.$toasted.show('Situation et nom de la société obligatoires! ', this.ToastTabError)
                                            }
                                        }
                                    }else {
                                        this.$toasted.show('Téléphone et Email obligatoires! ', this.ToastTabError)
                                    }
                                }else {
                                    this.$toasted.show('Adresse obligatoires! ', this.ToastTabError)
                                } 
                        } else {
                            this.$toasted.show('Nom et Prénom obligatoires! ', this.ToastTabError)
                        }

            },
            /*================= retour à la premiere étape ==============*/
             returToFirstStep(){
                document.getElementById("firstStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthFirst');
                this.step = 1
            },

            returToSecondStep(){
                this.activeStep -= 1;
                this.isContractant = true,
                this.isPayment = false
                this.step = 2
                document.getElementById("secondStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthSecond');
            },

            checkToken() {
                Api().get('user/check/token')
                .then((resultat) => {
                // verifie si le token exist
                if (!resultat.data.ok) {
                    store.state.isUserLoggedIn = false;
                    store.dispatch("setUser", {});
                    store.dispatch("setToken", {});
                    this.showLoginForm = true
                    }
                }).catch((err) => {
                    // verifie  si le token est expiré
                    if(err.response.data.ok === false){
                    store.state.isUserLoggedIn = false;
                    store.dispatch("setUser", {});
                    store.dispatch("setToken", {});
                    this.showLoginForm = true
                    }
                });
            },
           
            disabledAfterToday(date) {
            const today = dayjs(new Date()).add(-1, 'day')
            return date < today;
            },
            disabledAfterTodayBirth(date) {
              const today = dayjs(new Date()).add(-1, 'day')
              return date > today;
            },
              //Date object formater to String
              DateFormater: function (TheDate) {
            if (TheDate) {
                return dayjs(TheDate).format('DD-MM-YYYY')
            }
            },
            
           
            SwitchButtonColor(){
                $(".swith-click").click(function() {
                    $(".swith-click").removeClass('active');
                    $(this).addClass("active");
                });
            },

           
            /*========== Fonction pour faire choix entre mrp ou mrp_rc ========*/
            Choix() {
                if (this.Mrp == true) {
                    this.choixOffreFinale = 'Mrp_value';
                    this.choixMrp.MrpRc = null;
                    this.mrpRcOption = false
                } else if(this.MrpRc == true) {
                    this.choixMrp.Mrp = null;
                    this.choixOffreFinale = 'Mrp_rc_value';
                    this.mrpRcOption = true
                    this.SwitchButtonColor()


                }
            },

            calculePrimeLocataire(){
                if(this.Mrp == true) {
                    // ==================== calcul de la premiere ligne ================
                    if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 <= this.configMrp.mrp_batiment.valeur &&  Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurDeux) {
                        this.prime_nette = 82150;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.monthly_payment = (this.prime_nette + this.taxe + this.accessoire)
                    } // ==================== calcul de la deuximene ligne ================
                    else if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 > this.configMrp.mrp_batiment.valeur && Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeur) {
                        this.prime_nette = 183800;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.monthly_payment = (this.prime_nette + this.taxe + this.accessoire)
                    } // ==================== calcul de la troisieme ligne ================
                    else if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 > this.configMrp.mrp_batiment.valeur && Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurTrois) {
                        this.prime_nette = 221300;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.monthly_payment = (this.prime_nette + this.taxe + this.accessoire)
                    } else {
                        this.$toasted.show( "Veuillez nous consulter !", this.ToastTabError)
                        this.monthly_payment = null
                    }
                }else if(this.MrpRc == true) {
                    // ==================== calcul de la premiere ligne ================
                    if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 <= this.configMrp.mrp_batiment.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurDeux && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurOne) {
                        this.prime_nette = 132150;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurOne
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } else if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 <= this.configMrp.mrp_batiment.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurDeux && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_ca.valeurOne && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurTwo) {
                        this.prime_nette = 157150;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurOne
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    }else if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 <= this.configMrp.mrp_batiment.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurDeux && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_ca.valeurTwo && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurThirt) {
                        this.prime_nette = 182150;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurOne
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } // ==================== calcul de la deuxieme ligne ================
                    else if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 > this.configMrp.mrp_batiment.valeur && Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeur && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurOne) {
                        this.prime_nette = 233800;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurDeux
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } else if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 > this.configMrp.mrp_batiment.valeur && Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeur && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_ca.valeurOne && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurTwo) {
                        this.prime_nette = 258800;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurDeux
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } else if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 > this.configMrp.mrp_batiment.valeur && Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeur && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_ca.valeurTwo && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurThirt) {
                        this.prime_nette = 283800;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurDeux
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } 
                    // ==================== calcul de la troisieme ligne ================
                    else if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 > this.configMrp.mrp_batiment.valeur && Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurTrois && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurOne) {
                        this.prime_nette = 271300;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurTrois
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } else if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 > this.configMrp.mrp_batiment.valeur && Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurTrois && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_ca.valeurOne && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurTwo) {
                        this.prime_nette = 296300;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurTrois
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } else if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 > this.configMrp.mrp_batiment.valeur && Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) * 180 <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurTrois && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_ca.valeurTwo && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurThirt) {
                        this.prime_nette = 321300;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurTrois
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    }else  {
                        this.$toasted.show( "Veuillez nous consulter !", this.ToastTabError)
                        this.monthly_payment = null
                    }
                }
            },

            calculePrimeProprio(){
                if(this.Mrp == true) {
                     // ====================== calcul de la premiere ligne ================
                    if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_batiment.valeur &&  Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurDeux) {
                        this.prime_nette = 82150;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.monthly_payment = (this.prime_nette + this.taxe + this.accessoire)
                    } // ==================== calcul de la deuximene ligne ================
                    else if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_batiment.valeur && Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeur) {
                        this.prime_nette = 183800;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.monthly_payment = (this.prime_nette + this.taxe + this.accessoire)
                    } // ==================== calcul de la troisieme ligne ================
                    else if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_batiment.valeur && Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurTrois) {
                        this.prime_nette = 221300;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.monthly_payment = (this.prime_nette + this.taxe + this.accessoire)
                    } else {
                        this.$toasted.show( "Veuillez nous consulter !", this.ToastTabError)
                        this.monthly_payment = null
                    }
                }else if(this.MrpRc == true) {
                    // ==================== calcul de la premiere ligne ================
                    if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_batiment.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurDeux && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurOne) {
                        this.prime_nette = 132150;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurOne
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } else if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_batiment.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurDeux && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_ca.valeurOne && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurTwo) {
                        this.prime_nette = 157150;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurOne
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    }else if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_batiment.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurDeux && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_ca.valeurTwo && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurThirt) {
                        this.prime_nette = 182150;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurOne
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } // ==================== calcul de la deuxieme ligne ================
                    else if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_batiment.valeur && Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeur && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurOne) {
                        this.prime_nette = 233800;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurDeux
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } else if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_batiment.valeur && Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeur && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_ca.valeurOne && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurTwo) {
                        this.prime_nette = 258800;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurDeux
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } else if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_batiment.valeur && Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeur && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_ca.valeurTwo && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurThirt) {
                        this.prime_nette = 283800;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurDeux
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } 
                    // ==================== calcul de la troisieme ligne ================
                    else if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_batiment.valeur && Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurTrois && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurOne) {
                        this.prime_nette = 271300;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurTrois
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } else if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_batiment.valeur && Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurTrois && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_ca.valeurOne && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurTwo) {
                        this.prime_nette = 296300;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurTrois
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } else if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_batiment.valeur && Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_batiment.valeurDeux && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_mobilier.valeur && Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_mobilier.valeurTrois && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) > this.configMrp.mrp_ca.valeurTwo && Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) <= this.configMrp.mrp_ca.valeurThirt) {
                        this.prime_nette = 321300;
                        this.taxe = (this.prime_nette + this.accessoire) * 14 / 100
                        this.primeRc = this.configMrp.mrp_rc.valeurTrois
                        this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                    } else {
                        this.$toasted.show( "Veuillez nous consulter !", this.ToastTabError)
                        this.monthly_payment = null
                    }
                }
            },

            //Control des champs pour validation
            fieldsControl() {

                this.Choix()
                            if (this.choixOffreFinale == 'Mrp_value'){
                                if(this.qualiteassure == "occupant") {
                                    if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) ){
                                        if (Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, ""))){
                                                this.calculePrimeProprio();
                                                if(this.monthly_payment != null) {
                                                    this.SkipSimule = true,
                                                    this.Simule = false,
                                                    this.branche = 'Multirisque Professionnelle'
                                                    this.Assureur = 'FINAFRICA'
                                                }else {
                                                    this.SkipSimule = false,
                                                    this.Simule = true,
                                                    this.branche = 'Multirisque Professionnelle'
                                                    this.Assureur = 'FINAFRICA'
                                                }
                                        } else {
                                            this.$toasted.show('Veuillez renseigner la valeur du mobiler ! ', this.ToastTabError)
                                        }
                                } else {
                                    this.$toasted.show( "Veuillez renseigner la valeur du bâtiment !", this.ToastTabError)
                                }
                                }else if(this.qualiteassure == 'locataire') {
                                    if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) ){
                                        if (Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, ""))){ 
                                                this.calculePrimeLocataire();
                                                if(this.monthly_payment != null) {
                                                    this.SkipSimule = true,
                                                    this.Simule = false,
                                                    this.branche = 'Multirisque Professionnelle'
                                                    this.Assureur = 'FINAFRICA'
                                                }else {
                                                    this.SkipSimule = false,
                                                    this.Simule = true,
                                                    this.branche = 'Multirisque Professionnelle'
                                                    this.Assureur = 'FINAFRICA'
                                                }
                                                // this.SkipSimule = true,
                                                // this.Simule = false,
                                                // this.branche = 'MRP'
                                                // this.Assureur = 'FINAFRICA'
                                        } else {
                                            this.$toasted.show('Veuillez renseigner la valeur du mobiler ! ', this.ToastTabError)
                                        }
                                    } else {
                                        this.$toasted.show( "Veuillez renseigner le loyer mensuel !", this.ToastTabError)
                                    }
                                }
                            } else if (this.choixOffreFinale == 'Mrp_rc_value'){
                                if(this.qualiteassure == "occupant") {
                                    if(Number(this.valeur_proprio.replace(/[^0-9.-]+/g, "")) ){
                                        if(Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, ""))) {
                                            if (Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, "")) ){
                                                this.calculePrimeProprio ();
                                                if(this.monthly_payment != null) {
                                                    this.SkipSimule = true,
                                                    this.Simule = false,
                                                    this.branche = 'Multirisque Professionnelle'
                                                    this.Assureur = 'FINAFRICA'
                                                }else {
                                                    this.SkipSimule = false,
                                                    this.Simule = true,
                                                    this.branche = 'Multirisque Professionnelle'
                                                    this.Assureur = 'FINAFRICA'
                                                }
                                                // this.SkipSimule = true,
                                                // this.Simule = false,
                                                // this.branche = 'MRP'
                                                // this.Assureur = 'FINAFRICA'
                                            } else {
                                                this.$toasted.show("Veuiller renseigner le chiffre d'affaires !", this.ToastTabError)
                                            }
                                        } else {
                                            this.$toasted.show("Veuillez renseigner la valeur du mobiler !", this.ToastTabError)
                                        }
                                    } else {
                                        this.$toasted.show( "Veuiller renseigner la valeur du bâtiment !", this.ToastTabError)
                                    }
                                }else if(this.qualiteassure == 'locataire') {
                                    if(Number(this.valeur_location.replace(/[^0-9.-]+/g, "")) ){
                                        if(Number(this.valeur_mobilier.replace(/[^0-9.-]+/g, ""))) { 
                                            if (Number(this.chiffre_affaire.replace(/[^0-9.-]+/g, ""))){
                                                this.calculePrimeLocataire();
                                                if(this.monthly_payment != null) {
                                                    this.SkipSimule = true,
                                                    this.Simule = false,
                                                    this.branche = 'Multirisque Professionnelle'
                                                    this.Assureur = 'FINAFRICA'
                                                }else {
                                                    this.SkipSimule = false,
                                                    this.Simule = true,
                                                    this.branche = 'Multirisque Professionnelle'
                                                    this.Assureur = 'FINAFRICA'
                                                }
                                                // this.SkipSimule = true,
                                                // this.Simule = false,
                                                // this.branche = 'MRP'
                                                // this.Assureur = 'FINAFRICA'
                                            } else {
                                                this.$toasted.show("Veuiller renseigner le chiffre d'affaires !", this.ToastTabError)
                                            }
                                        } else {
                                            this.$toasted.show("Veuiller renseigner la valeur du mobiler !", this.ToastTabError)
                                        }
                                } else {
                                    this.$toasted.show( "Veuiller renseigner le loyer mensuel", this.ToastTabError)
                                }
                                }

                                
                            } 
            },

            CheckFieldChange(){
                this.SkipSimule = false
                this.Simule = true
            },

            switchMrp(){
                this.Choix()
                this.Mrp = true;
                this.MrpRc = false;
                this.rc = false
                this.monthly_payment= null
                this.CheckFieldChange()
                this.ClearForm()
            },
            switchMrpRc(){
                this.Choix()
                this.MrpRc = true;
                this.Mrp = false;
                this.rc = false
                this.monthly_payment= null
                this.CheckFieldChange()
                this.ClearForm()
            },
            switchRc(){
                this.Choix()
                this.MrpRc = false;
                this.Mrp = false;
                this.rc = true
                this.monthly_payment= null
            },
            /*nextStep() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                }, 600);
            },*/
        
            ClearForm () {
                this.valeur_location = null
                this.valeur_proprio = null
                this.chiffre_affaire = null
                this.valeur_mobilier = null
            },
            clearFormContractant (){
                this.ContractantFields.Nom = ''
                this.ContractantFields.Prenom = null
                this.ContractantFields.Telephone = null
                this.ContractantFields.Email = null
                this.ContractantFields.Adresse = null
            },

            yearsDiff(){
                const date1 = dayjs(this.dateNaiss).year();
                const date2 = new Date().getFullYear();
                let daydiff = date2 - date1
                this.age = daydiff;

                if (this.age <0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.dateNaiss = null
                } else if (this.age) {
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas être Supérieur à 18 ans! ", this.ToastTabError)
                        this.dateNaiss = null
                    }else if(this.age > 55){
                        this.$toasted.show( "L'année de naissance doit être inferieur ou égale à 55 ans!", this.ToastTabError)
                        this.dateNaiss = null
                    }
                }
                else if (this.age<=0) {
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas etre Supérieur à 18 ans! ", this.ToastTabError)
                        this.dateNaiss = null
                    }
                }
                //this.CheckFieldChange()
            },

          

          

          

            /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
            onlyNumber($event) {
                let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
                if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                    $event.preventDefault();
                }
            },

            dateDiff () {
                if (this.dateEffet === '' && this.duree === '') this.dateEcheance = '';
                let inter = dayjs(this.dateEffet).add(this.duree, 'month').format('YYYY-MM-DD');
                this.dateEcheance = dayjs(inter).add(-1, 'day').format('YYYY-MM-DD')
            },

            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },

            isDesktop: function () {
                if (screen.width > 768) {
                    return true;
                } else {
                    return false;
                }
            },

            nextStep() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                        this.isAssure = true
                }, 600);
            },



           

            BackToBenefForm(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.e1 = 4;
                    this.isContractant = false,
                        this.isAssure = false,
                        this.isBenef = true
                }, 500);
            },

            validField() {
                this.step = 6
                document.getElementById("testup").classList.add('widthFive');
                document.getElementById("thirtStep").classList.add('checked');
                 this.nextStep4()
                this.bottomPushNotif =false 
            }
        },
        

        created() {
            this.checkToken()
            this.configMrp = configMrpConfig[0].mrp
            //this.QuestionMedical = QMNsia.MediaclQuestion
        },
        mounted() {
            window.scrollTo(0, 0);
        }
    }
</script>

<style lang="less" scoped>
    @import "../../assets/css/button.css";
    @import "../../assets/css/devis_css.css";

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
.to-right {
  float: right!important;
}


    .form {
        background-color: #fff;
        padding: 1.5rem;
    }

    .form .page {
        height: auto;
    }

    button.next {
        position: absolute;
        bottom: 0;
        right: 0;
        margin-right: 1.5rem;
        margin-bottom: 1rem;
    }

    button.previous {
        position: absolute;
        bottom: 0;
        left: 0;
        margin-left: 1.5rem;
        margin-bottom: 1rem;
    }


    button.edit {
        position: absolute;
        bottom: 0;
        right: 0;
    }

    h4 {
        color: #29323a;
        margin-bottom: 15px;
        font-weight: 600;
    }




    html {
        background-color: #1a1a1a;
        overflow: hidden;
    }
    .middle {
        width: auto;
        text-align: center;
        /* Made by */
    }
    .middle h1 {
        font-family: "Inter", sans-serif;
        color: #fff;
    }
    .middle input[type="radio"] {
        display: none;
    }
    .middle input[type="radio"]:checked + .box {
        background-color: rgba(255, 164, 9, 0.07);
        transition: all .33s ease;
        border: 2px solid #ffa409;
        color: #29323a;
    }
    .middle input[type="radio"]:checked + .box span {
        color: #29323a;
        transform: translateY(70px);
    }
    .middle input[type="radio"]:checked + .box span:before {
        transform: translateY(0px);
        opacity: 1;
    }
    .middle .box {
        width: 220px;
        height: 150px;
        border-radius: 12px;
        background-color: #fff;
        transition: all 250ms ease;
        will-change: transition;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        position: relative;
        box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
        font-size: 10px;
        border: 1px solid #d9dee3;
        font-family: Open Sans,sans-serif;
        font-weight: 900;
    }
    .middle .box:hover {
        background-color: rgba(255, 164, 9, 0.07);
        transition: all .33s ease;
        border: 2px solid #ffa409;
    }
    .middle .box:hover span {
        color: #29323a;
    }

    .middle .box:active {
        transform: translateY(10px);
    }
    .middle .box span {
        position: absolute;
        transform: translate(0, 60px);
        left: 0;
        right: 0;
        padding-top: 15%;
        transition: all 300ms ease;
        font-size: 1.5em;
        user-select: none;
        color: #29323a;
    }
    .middle .box span:before {
        font-size: 1.2em;
        font-family: FontAwesome;
        display: block;
        transform: translateY(-80px);
        opacity: 0;
        transition: all 300ms ease-in-out;
        font-weight: normal;
        color: #fff;
    }
    .middle p {
        color: #fff;
        font-family: "Inter", sans-serif;
        font-weight: 400;
    }
    .middle p a {
        text-decoration: underline;
        font-weight: bold;
        color: #fff;
    }
    .middle p span:after {
        content: "\f0e7";
        font-family: FontAwesome;
        color: yellow;
    }

    .widthFirst{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:32.55556%;
    }
    .widthSecond{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:65.11112%;
    }
    .widthThirt{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:100%;
    }












    .paralax-cover-image {
        background-image: url('../../assets/img/assurance/assurPlus.jpg');
        position: relative;
        background-size: contain!important;
        background-position: 50%;
        min-height: 230px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
        background-attachment: fixed;
        background-position: 50% 40px;
    }



    .paralax-cover-image_mobile {
        background-image: url('../../assets/img/assurance/assurPlus_mobile.jpg');
        position: relative;
        background-size: contain;
        background-position: 50%;
        min-height: 150px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        //padding: 20px;
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
        // background-attachment: fixed;
        background-position: 100% 40px;
    }


    .hero {
        position: relative;
        background-size: cover;
        background-position: center center;
        height: 680px;
        min-height: 320px;
        max-height: 100%;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        align-items: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center;
        padding: 20px;
    }
    .hero .content_home {
        position: relative;
        min-height: 280px;
        width: 100%;
        margin-left: 8.5%;
        z-index: 2;
        /*//background: red;*/
    }
    .hero .content_home p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        width: 100%;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    .to-left {
  text-align: left;
}


// css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>
